import(/* webpackMode: "eager" */ "/vercel/path0/src/app/careers/page.tsx");
